// AWS Amplify API disabled — backend migrated to EC2. Auth still used for legacy Cognito calls.
import { Auth } from "aws-amplify";
import { OffLineAPI } from "../offline-auth/api";
import axios from "axios";
import { encryptData } from "../lib/crypto";

var _API = OffLineAPI;

// A clean axios instance for third-party calls. The default `axios` instance
// has a global request interceptor (users.js) that attaches app headers
// (X-Clinic-Subdomain, Authorization, tenantId) to EVERY request. On a
// cross-origin call those custom headers trigger a CORS preflight the external
// host rejects — surfacing as a "Network Error". axios.create() does NOT inherit
// the default instance's interceptors, so this stays a simple, header-free GET.
const plainAxios = axios.create();

let listpromise;
let docschpro;
let apptpro;
// let appointmentpro;
let docslotspro;
let docdatepro;
let waitingroompro;
let patientmedicpro;
let patmedicalpro;
let drugpro;
let patdrugpro;
export async function getAxios(id) {
    // fawazahmed0 currency-api. The jsdelivr CDN is the reliable primary; the
    // pages.dev mirror is the documented fallback (it goes down intermittently,
    // which surfaces as a "Network Error"). Try them in order and only fail if
    // both are unreachable, so the caller can handle it instead of crashing on
    // an empty response.
    const urls = [
        `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${id}.json`,
        `https://latest.currency-api.pages.dev/v1/currencies/${id}.json`,
    ];
    let lastError;
    for (const url of urls) {
        try {
            const response = await plainAxios({ method: "get", url, responseType: "json" });
            if (response?.data?.[id]) return response;
        } catch (error) {
            lastError = error;
            console.log("currency-api request failed, trying fallback...", url);
        }
    }
    throw lastError || new Error(`Currency rates unavailable for ${id}`);
}

export async function scan(formData, query) {
    const headers = {
        "Content-Type": "multipart/form-data",
    };
    let result;
    await axios({ method: "post", url: `${process.env.REACT_APP_Scan}?query=${encryptData(query)}`, data: formData, headers: headers })
        .then((res) => {
            result = res.data;
        })
        .catch((err) => {
            result = err.response.data;
        });
    return result;
}
export async function deleteS3(query) {
    const headers = {
        "Content-Type": "multipart/form-data",
    };
    let result;
    await axios({ method: "post", url: `${process.env.REACT_APP_Delete}?query=${encryptData(query)}`, headers: headers })
        .then((res) => {
            // console.log("resres", res)
            result = res.data;
        })
        .catch((err) => {
            result = err.response.data;
        });
    return result;
}

export async function getDoctorSchedules(id) {
    if (docschpro) {
        _API.cancel(docschpro, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    docschpro = _API.get("appointment", `/doctor-schedules?id=${id}&query=${atoken}`);
    return docschpro;
}
export async function getappointment(id) {
    if (apptpro) {
        _API.cancel(apptpro, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    apptpro = _API.get("appointment", `/getappointment?appointmentId=${id}&query=${atoken}`);
    return apptpro;
}

export async function getappointmentData(id) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.get("appointment", `/getappointment?appointmentId=${id}&query=${atoken}`);
}

export async function getPastAppointmentInfo(patientId, doctorId, appointmentId) {
    return _API.get("appointment", `/pastappointmentget?patientId=${patientId}&doctorId=${doctorId}&appointmentId=${appointmentId}`);
}

// export function getappointmenttoken(id) {
//     if (appointmentpro) {
//         _API.cancel(appointmentpro, "MY cancelation");
//     }
//     appointmentpro = _API.get("appointment", `/getConsultation?appointmentId=${id}`);
//     return appointmentpro;
// }
export async function getDoctorSlots(id) {
    if (docslotspro) {
        _API.cancel(docslotspro, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    docslotspro = _API.get("appointment", `/doctor-slots?id=${id}&query=${atoken}`);
    return docslotspro;
}

export async function createAppointment(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/appointment?query=${atoken}`, { body });
}

export async function followupdate(doctorId, patientId, clinicId, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put(`appointment`, `/followup?doctorId=${doctorId}&patientId=${patientId}&clinicId=${clinicId}&query=${atoken}`, { body });
}

export async function pastAppUploads(body) {
    return _API.put("appointment", `/pastAppUploads`, { body });
}

/////////check whether previous apptments are paid or not////

export async function checkPrevPostPaidAppt(query) {
    const atoken = localStorage.getItem("secureid_access_token");
    query = query ? (query += `&query=${atoken}`) : `?query=${atoken}`;
    return _API.get("appointment", `/checkPostPayment${query}`);
}

export async function postPaidAppointment(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/postPayment?query=${atoken}`, { body });
}

export async function appointmentList(role, status, from, to, type, searchKey) {
    if (listpromise) {
        _API.cancel(listpromise, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    let query = "";
    if (from && to) {
        query = `from=${from}&to=${to}`;
    }
    if (status !== null) {
        query += query !== "" ? `&status=${JSON.stringify(status)}` : `status=${JSON.stringify(status)}`;
    }
    if (type !== null) {
        query += query !== "" ? `&type=${type}` : `type=${type}`;
    }
    // console.log("searchKey===",searchKey)

    query += searchKey && searchKey !== "" ? `&searchKey=${searchKey}` : "";
    query += `&query=${atoken}`;
    // if(searchKey !== null){
    //     query += query !== "" ? `&searchKey=${searchKey}` : `&searchKey=${searchKey}`;
    // }
    listpromise = _API.get("appointment", `/appointment/${role}?${query}`);
    return listpromise;
}

// export function cancelListAPI() {
// if (listpromise) {
//     _API.cancel(listpromise, "MY cancelation");
// }
// }

export async function getDateAppointments(date, doctorId) {
    if (docdatepro) {
        _API.cancel(docdatepro, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    // console.log('dddd',doctorId);
    let from = new Date(date);
    from.setHours(0, 0, 0, 0);
    let to = new Date(date);
    to.setHours(23, 59, 59, 59);
    let query = `from=${from.valueOf()}&to=${to.valueOf()}`;
    query += `&query=${atoken}`;
    docdatepro = _API.get("appointment", `/doctor-appointment/${doctorId}?${query}`);
    return docdatepro;
}

export async function getWaitingRoomList() {
    if (waitingroompro) {
        _API.cancel(waitingroompro, "MY cancelation");
    }
    const token = localStorage.getItem("secureid_access_token");
    waitingroompro = _API.get("schedule", `/waitingroom?query=${token}`);
    return waitingroompro;
}
export async function getPatientMedicalFiles() {
    if (patmedicalpro) {
        _API.cancel(patmedicalpro, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    patmedicalpro = _API.get("appointment", `/patientmedical?query=${atoken}`);
    return patmedicalpro;
}
export async function getPatientMedicalFilesById(id) {
    if (patientmedicpro) {
        _API.cancel(patientmedicpro, "MY cancelation");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    patientmedicpro = _API.get("appointment", `/patientmedical?userId=${id}&query=${atoken}`);
    return patientmedicpro;
}
export async function createPatientMedicalFiles(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/patientmedical?query=${atoken}`, { body });
}
export async function deletePatientMedicalFile(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/deletepatientmedicalfile?query=${atoken}`, { body });
}

export async function createPatientDrugAllegies(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/drugalergies?sub=${localStorage.getItem("sub")}&query=${atoken}`, { body });
}
export async function getPatientDrugAllegies() {
    if (drugpro) {
        _API.cancel(drugpro, "MY cancelation");
    }
    drugpro = _API.get("appointment", `/drugalergies?userId=${localStorage.getItem("sub")}`);
    return drugpro;
}
export function getPatientDrugAllegiesById(id) {
    if (patdrugpro) {
        _API.cancel(patdrugpro, "MY cancelation");
    }
    patdrugpro = _API.get("appointment", `/drugalergies?userId=${id}&sub=${localStorage.getItem("sub")}`);
    return patdrugpro;
}
export async function updatePatientDrugAllegies(id, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("appointment", `/drugalergies?id=${id}&sub=${localStorage.getItem("sub")}&query=${atoken}`, { body });
}
export async function deletePatientDrugAllegies(id) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.del("appointment", `/drugalergies?id=${id}&sub=${localStorage.getItem("sub")}&query=${atoken}`);
}
export async function pastAppointments(id, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/past/appointments/${id}?query=${atoken}`, { body });
}

export async function sendInviteLink(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/inviteuser?query=${atoken}`, { body });
}

export async function cancelAppt(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("appointment", `/cancel-appointment?query=${atoken}`, { body });
}

export function getDoctorSignature(did = null) {
    let path = did !== null ? `/getdoctorsigns?userId=${did}` : `/getdoctorsigns?userId=${localStorage.getItem("sub")}`;
    return _API.get("appointment", path);
}
export function enterParticipantLogs(body) {
    return _API.post("appointment", `/enterparticipantlogs`, { body });
}

export function exitParticipantLogs(body) {
    return _API.post("appointment", `/exitparticipantlogs`, { body });
}
export function saveCallLogs(body) {
    return API.post("appointment", `/savelogs`, { body });
}

export async function deleteDrugAllergies(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("appointment", `/deletedrugalergy?query=${atoken}`, { body });
}

export async function getReports(query) {
    // if (reportspro) {
    //     _API.cancel(reportspro, "MY cancelation");
    // }
    const atoken = localStorage.getItem("secureid_access_token");
    // reportspro = _API.get("appointment", `/getReports?type=${query}&query=${atoken}`);
    // return reportspro;
    return _API.get("appointment", `/getReports?type=${query}&query=${atoken}`);
}

export async function getApptbyId(from, to, id, role, skip, limit) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.get("appointment", `/getapptbyid?from=${from}&to=${to}&id=${id}&role=${role}&skip=${skip}&limit=${limit}&query=${atoken}`);
}
